export default function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isPlaceholder.js
// module id = 184
// module chunks = 1